// The contact form: each field is checked before Shopify gets the message, with the reason decoding in under the
// field; a field is re-checked as soon as it's fixed, never while someone is still typing a fresh one. After sending,
// the page thanks the visitor by first name. Ported from the approved concept (concept/src/09-pages.js).
import { $, session, setText, decode, onPageIn, checkFirst } from 'fx';

const page = $('[data-contact]');
if (page) init(page);

function init(page) {
  const T = JSON.parse(($('#contact-strings') || {}).textContent || '{}');

  // After sending: "Thanks, Fredrik."
  const doneTitle = $('#c-done-title', page);
  if (doneTitle) {
    const name = session.get('9ine-contact-name');
    session.remove('9ine-contact-name');
    if (name) setText(doneTitle, doneTitle.dataset.thanks.replace('[name]', name));
    onPageIn(() => {
      decode(doneTitle, { step: 26, hold: 160 });
      doneTitle.focus({ preventScroll: true });
    });
    return;
  }

  const form = $('#contact-form', page);
  if (!form) return;
  form.noValidate = true;
  const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  const RULES = {
    'c-name': (v) => (v ? '' : T.name),
    'c-email': (v) => (!v ? T.email : EMAIL_RE.test(v) ? '' : T.emailFormat),
    'c-country': (v) => (v ? '' : T.country),
    'c-message': (v) => (v ? '' : T.message),
    'c-consent': (v, el) => (el.checked ? '' : T.consent)
  };

  function showErr(id, msg) {
    const err = $(`#${id}-err`, page);
    if (!err || err._msg === msg) return;
    err._msg = msg;
    setText(err, msg || '');
    if (msg) decode(err, { step: 12, hold: 90 });
  }
  function check(id) {
    const el = $(`#${id}`, page);
    const msg = RULES[id](el.value.trim(), el);
    el.setAttribute('aria-invalid', String(!!msg));
    showErr(id, msg);
    return !msg;
  }

  Object.keys(RULES).forEach((id) => {
    const el = $(`#${id}`, page);
    if (!el) return;
    el.addEventListener(el.type === 'checkbox' ? 'change' : 'input', () => { if (el.getAttribute('aria-invalid') === 'true') check(id); });
    if (el.type !== 'checkbox') el.addEventListener('blur', () => { if (el.hasAttribute('aria-invalid')) check(id); });
  });

  // checked first, at the window (fx.js checkFirst), so Shopify's bot check never sends a message that isn't right
  checkFirst(form, () => {
    const bad = Object.keys(RULES).filter((id) => $(`#${id}`, page) && !check(id));
    if (bad.length) {
      $(`#${bad[0]}`, page).focus();
      return false;
    }
    session.set('9ine-contact-name', $('#c-name', page).value.trim().split(/\s+/)[0]);
    return true;
  });
}
